




































































































































































































import {Component, Vue} from 'vue-property-decorator';
import IconButton from '@c/controls/IconButton.vue';
import Loading from '@c/controls/Loading.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import DeleteDialog from '@c/DeleteDialog.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import DateTimePicker from '@c/controls/DateTimePicker.vue';
import router from '@/router';
import trendtaskStoreModule from '@/store/modules/trendtaskModule';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {TrendTaskTableHeader} from './interfaces';

@Component({
  components: {
    IconButton,
    DateTimePicker,
    SimpleDialog,
    DeleteDialog,
    CancelChangesDialog,
    Loading,
  },
})
export default class TrendTask extends Vue {
  loading = true;
  error = false;
  saving = false;
  valid = true;
  measurementEditDialog = false;
  currentMeasurementIdx = -1;
  currentMeasurementId: number | null = null;
  currentTopWarningBoundary: number | null = null;
  currentTopDangerBoundary: number | null = null;
  currentTopErrorBoundary: number | null = null;
  currentBottomWarningBoundary: number | null = null;
  currentBottomDangerBoundary: number | null = null;
  currentBottomErrorBoundary: number | null = null;

  task: any = {};
  modules: any = [];
  measurements_list: any = [];

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';
  RegExPattern = /^([0-9A-Fa-f]{12})$/;
  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';
  nonNegativeNumberRule = (v: any) => v >= 0 || 'Поле должно быть неотрицательным числом';
  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  trend_types = [
    {name: 'среднее значение', id: 0},
    {name: 'медианное значение', id: 1},
    {name: 'максимум', id: 2},
  ];

  measurementsHeaders: TrendTaskTableHeader[] = [
    {
      text: 'Описание',
      value: 'module_type_measurement_description',
      sortable: true,
    },
    {
      text: 'Верхняя граница предупреждения',
      value: 'top_warning_boundary',
      sortable: false,
    },
    /* {
      text: 'В.гр.опасного значения',
      value: 'top_danger_boundary',
      sortable: false,
    },
    {
      text: 'В.гр.ошибки',
      value: 'top_error_boundary',
      sortable: false,
    },
    {
      text: 'Н.гр.предупреждения',
      value: 'bottom_warning_boundary',
      sortable: false,
    },
    {
      text: 'Н.гр.опасного значения',
      value: 'bottom_danger_boundary',
      sortable: false,
    },
    {
      text: 'Н.гр.ошибки',
      value: 'bottom_error_boundary',
      sortable: false,
    }, */
    {
      text: 'Действия',
      value: 'actions',
      sortable: false,
      width: 90,
    },
  ];

  async onSave() {
    const err_container = this.$refs.err_text as any;
    this.valid = await (this.$refs.form as any).validate();
    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }
    if (err_container) err_container.innerText = 'Обрабатываю...';
    try {
      await trendtaskStoreModule.save(this.task);
    } catch (err) {
      console.log(err);
      if (err_container) err_container.innerText = 'Ошибка обновления: ' + err;
      return;
    }
    if (err_container) err_container.innerText = '';
    router.push('/trends');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  onChange() {
    this.changed = true;
  }

  // Действия при изменении поля
  async onChangeModule() {
    this.changed = true;
  }

  // Действия при изменении поля
  async onChangeMeasurement() {
    this.changed = true;
    this.task.event_name = this.modules_measurements.find(
      (ms: any) => ms.alias == this.task.field_name,
    )?.eventType;
  }

  get modules_measurements() {
    const module_type = this.modules.find((m: any) => m.guid == this.task.module_guid)?.type;
    return measurementsStoreModule.entities.filter((ms: any) => ms.moduleType == module_type);
  }

  async created() {
    await pmoduleModule.fetchAll();
    await measurementsStoreModule.fetchAll();
    this.modules = pmoduleModule.all;
    this.measurements_list = measurementsStoreModule.entities.filter(
      (ms: any) => ms.moduleType == 'SignalTrendTasks',
    );

    const taskId = this.$router.currentRoute.params.id;
    if (taskId) {
      const {data} = await trendtaskStoreModule.edit(taskId);
      this.task = data;
    } else {
      const {data} = await trendtaskStoreModule.create();
      this.task = data;
    }
    this.loading = false;
  }

  back() {
    const cancelChangesDialog = this.$refs.cancelChangesDialog as any;
    // если были внесены изменения на форме
    if (this.changed) {
      cancelChangesDialog.open('/trends');
    } else router.push('/trends');
  }

  setStartDate(value: number) {
    this.task.start_date = value;
  }

  addMeasurement() {
    this.currentMeasurementIdx = -1;
    this.currentMeasurementId = -1;
    this.currentTopWarningBoundary = null;
    this.currentTopDangerBoundary = null;
    this.currentTopErrorBoundary = null;
    this.currentBottomWarningBoundary = null;
    this.currentBottomDangerBoundary = null;
    this.currentBottomErrorBoundary = null;
    this.measurementEditDialog = true;
  }

  editMeasurement(item: any) {
    this.currentMeasurementIdx = this.task.measurements.indexOf(item);
    this.currentMeasurementId = item.module_type_measurement_id;
    this.currentTopWarningBoundary = item.top_warning_boundary;
    this.currentTopDangerBoundary = item.top_danger_boundary;
    this.currentTopErrorBoundary = item.top_error_boundary;
    this.currentBottomWarningBoundary = item.bottom_warning_boundary;
    this.currentBottomDangerBoundary = item.bottom_danger_boundary;
    this.currentBottomErrorBoundary = item.bottom_error_boundary;
    this.measurementEditDialog = true;
  }

  deleteMeasurement(item: any) {
    const index = this.task.measurements.indexOf(item);
    const deleteDialog = this.$refs.deleteDialog as any;
    const itemName: string = item.module_type_measurement_description;
    deleteDialog.open(
      {index, itemName},
      {
        deleteCallback: async (elem: any) => {
          deleteDialog.close();
          this.task.measurements.splice(elem, 1);
        },
      },
    );
  }

  measurementSettingsChanged() {
    if (this.currentMeasurementIdx >= 0) {
      this.task.measurements[
        this.currentMeasurementIdx
      ].module_type_measurement_id = this.currentMeasurementId;
      this.task.measurements[
        this.currentMeasurementIdx
      ].module_type_measurement_description = this.measurements_list.find(
        (m: any) => m.id == this.currentMeasurementId,
      ).name;
      this.task.measurements[
        this.currentMeasurementIdx
      ].top_warning_boundary = this.currentTopWarningBoundary;
      this.task.measurements[
        this.currentMeasurementIdx
      ].top_danger_boundary = this.currentTopDangerBoundary;
      this.task.measurements[
        this.currentMeasurementIdx
      ].top_error_boundary = this.currentTopErrorBoundary;
      this.task.measurements[
        this.currentMeasurementIdx
      ].bottom_warning_boundary = this.currentBottomWarningBoundary;
      this.task.measurements[
        this.currentMeasurementIdx
      ].bottom_danger_boundary = this.currentBottomDangerBoundary;
      this.task.measurements[
        this.currentMeasurementIdx
      ].bottom_error_boundary = this.currentBottomErrorBoundary;
    } else {
      this.task.measurements.push({
        module_type_measurement_id: this.currentMeasurementId,
        module_type_measurement_description: this.measurements_list.find(
          (m: any) => m.id == this.currentMeasurementId,
        ).name,
        top_warning_boundary: this.currentTopWarningBoundary,
        top_danger_boundary: this.currentTopDangerBoundary,
        top_error_boundary: this.currentTopErrorBoundary,
        bottom_warning_boundary: this.currentBottomWarningBoundary,
        bottom_danger_boundary: this.currentBottomDangerBoundary,
        bottom_error_boundary: this.currentBottomErrorBoundary,
      });
    }
    this.measurementEditDialog = false;
  }
}
